import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { ArrowUpRight, Menu, X } from "lucide-react";

const links = [
  { to: "/", label: "Accueil", testid: "nav-link-accueil" },
  { to: "/newsletter", label: "Newsletter", testid: "nav-link-newsletter" },
  { to: "/offre", label: "L'accompagnement", testid: "nav-link-offre" },
  { to: "/a-propos", label: "À propos", testid: "nav-link-about" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <header className="fixed top-0 inset-x-0 z-50 bg-[#0A0C10]/80 backdrop-blur-xl border-b border-[#262B3D]">
      <div className="container-site flex items-center justify-between h-16">
        <Link to="/" data-testid="header-logo" className="flex items-center gap-2 group">
          <img src="/logo-icon.png" alt="La Bascule" className="w-8 h-8 rounded-lg transition-transform duration-300 group-hover:-rotate-12" />
          <span className="font-heading font-bold text-lg tracking-tight">La Bascule</span>
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              data-testid={l.testid}
              className={`text-sm font-medium transition-colors duration-300 hover:text-primary ${
                location.pathname === l.to ? "text-primary" : "text-slate-300"
              }`}
            >
              {l.label}
            </Link>
          ))}
        </nav>

        <div className="hidden md:block">
          <button
            data-testid="nav-cta-apply"
            onClick={() => navigate("/offre#postuler")}
            className="group inline-flex items-center gap-2 bg-primary text-[#0A0C10] font-semibold text-sm px-5 py-2.5 rounded-full transition-all duration-300 hover:bg-[#00C885] hover:shadow-[0_0_30px_rgba(0,229,153,0.35)]"
          >
            Booker mon Check Up
            <ArrowUpRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </button>
        </div>

        <button
          data-testid="nav-mobile-toggle"
          className="md:hidden text-slate-200"
          onClick={() => setOpen(!open)}
          aria-label="Menu"
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      <AnimatePresence>
        {open && (
          <motion.nav
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            className="md:hidden border-t border-[#262B3D] bg-[#0A0C10]/95 backdrop-blur-xl overflow-hidden"
          >
            <div className="container-site py-4 flex flex-col gap-4">
              {links.map((l) => (
                <Link
                  key={l.to}
                  to={l.to}
                  data-testid={`${l.testid}-mobile`}
                  onClick={() => setOpen(false)}
                  className="text-base font-medium text-slate-200 hover:text-primary transition-colors"
                >
                  {l.label}
                </Link>
              ))}
              <button
                data-testid="nav-cta-apply-mobile"
                onClick={() => { setOpen(false); navigate("/offre#postuler"); }}
                className="inline-flex items-center justify-center gap-2 bg-primary text-[#0A0C10] font-semibold px-5 py-3 rounded-full"
              >
                Booker mon Check Up <ArrowUpRight className="w-4 h-4" />
              </button>
            </div>
          </motion.nav>
        )}
      </AnimatePresence>
    </header>
  );
};
